// TODO:  Créer composant JS

// Slider
function navigation(slider) {
  let wrapper, dots;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement('div');
    var classNames = className.split(' ');
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv('up-slider_wrapper');
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv('up-slider_dots');
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv('up-slider_dot');
      dot.addEventListener('click', () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    wrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide ? dot.classList.add('up-slider_dot--active') : dot.classList.remove('up-slider_dot--active');
    });
  }

  // Auto-rotate
  let timeout;
  let mouseOver = false;
  function clearNextTimeout() {
    clearTimeout(timeout);
  }
  function nextTimeout() {
    clearTimeout(timeout);
    if (mouseOver) return;
    timeout = setTimeout(() => {
      slider.next();
    }, 2000);
  }

  slider.on('created', () => {
    markup();
    updateClasses();
    // slider.container.addEventListener("mouseover", () => {
    //     mouseOver = true
    //     clearNextTimeout()
    // })
    // slider.container.addEventListener("mouseout", () => {
    //     mouseOver = false
    //     nextTimeout()
    // })
    // nextTimeout()
  });
  // slider.on("dragStarted", clearNextTimeout)
  // slider.on("animationEnded", nextTimeout)
  // slider.on("updated", nextTimeout)

  slider.on('optionsChanged', () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on('slideChanged', () => {
    updateClasses();
  });
  slider.on('destroyed', () => {
    markup(true);
  });
}

if (document.getElementById('fc-reviews-slider')) {
  var slider = new KeenSlider(
    '#fc-reviews-slider',
    {
      mode: 'snap',
      loop: true,
      breakpoints: {
        '(max-width: 989px)': {
          slides: {
            origin: 'center',
            perView: 2,
            spacing: 15,
          },
        },
        '(max-width: 749px)': {
          slides: {
            origin: 'center',
            perView: 1.25,
            spacing: 15,
          },
        },
      },
      slides: {
        origin: 'center',
        perView: 3,
        spacing: 15,
      },
    },
    [navigation]
  );
}

if (document.getElementById('my-keen-slider')) {
  var slider2 = new KeenSlider(
    '#my-keen-slider',
    {
      mode: 'snap',
      loop: false,
      breakpoints: {
        '(max-width: 989px)': {
          slides: {
            perView: 2,
            spacing: 20,
          },
        },
        '(max-width: 749px)': {
          slides: {
            perView: 1.1,
            spacing: 10,
          },
        },
      },
      slides: {
        perView: 3,
        spacing: 30,
      },
    },
    [navigation]
  );
}

if (document.getElementById('fc-bandes-slider')) {
  var slider = new KeenSlider(
    '#fc-bandes-slider',
    {
      mode: 'snap',
      loop: false,
      initial: 1, // start cursor on 2nd img
      breakpoints: {
        '(max-width: 989px)': {
          slides: {
            origin: 'center',
            perView: 2,
            spacing: 10,
          },
        },
        '(max-width: 749px)': {
          slides: {
            origin: 'center',
            perView: 2,
            spacing: 10,
          },
        },
      },
      slides: {
        origin: 'center',
        perView: 3,
        spacing: 20,
      },
    },
    [navigation]
  );
}

if (document.getElementById('fc-keen-slider')) {
  var slider = new KeenSlider('#fc-keen-slider', {
    loop: true,
    mode: 'free',
    breakpoints: {
      '(max-width: 1299px)': {
        slides: { origin: 0.1, perView: 4, spacing: 20 },
      },
      '(max-width: 989px)': {
        slides: { origin: 0.1, perView: 3, spacing: 15 },
      },
      '(max-width: 749px)': {
        slides: { origin: 0.1, perView: 2, spacing: 10 },
      },
    },
    slides: {
      origin: 0.1,
      perView: 5,
      spacing: 25,
    },
  });
}

function scaleElement(element, slides_idx) {
  var scale_size = 0.2;
  if (window.matchMedia('(max-width: 989px)').matches) {
    var scale = 1 - Math.max(scale_size - scale_size * slides_idx.portion, 0);
  } else {
    var scale = 1 - scale_size * Math.abs(0.38 - slides_idx.distance);
  }

  var style = `scale(${scale})`;
  element.style.transform = style;
  element.style['-webkit-transform'] = style;
}

document.querySelectorAll("[id*='fc-ebook-slider']").forEach((carousel) => {
  var slider = new KeenSlider(
    carousel,
    {
      mode: 'snap',
      loop: true,
      breakpoints: {
        '(max-width: 1300px)': {
          slides: {
            origin: 'center',
            perView: 4,
            spacing: 40,
          },
        },
        '(max-width: 989px)': {
          slides: {
            origin: 'center',
            perView: 2.5,
            spacing: 40,
          },
        },
        '(max-width: 749px)': {
          slides: {
            origin: 'center',
            perView: 1.75,
            spacing: 30,
          },
        },
        '(max-width: 500px)': {
          slides: {
            origin: 'center',
            perView: 1.5,
            spacing: 30,
          },
        },
      },
      slides: {
        origin: 'center',
        perView: 5,
        spacing: 40,
      },
      detailsChanged: (s) => {
        const slides = s.track.details.slides;
        s.slides.forEach((element, idx) => {
          scaleElement(element.querySelector('img'), slides[idx]);
        });
      },
    },
    [navigation]
  );
});

if (document.querySelector("[id*='up-sm-perso-slider']")) {
  function navigationBarby(slider) {
    let wrapper, arrowLeft, arrowRight;

    function markup(remove) {
      wrapperMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className, innerHTML) {
      var div = document.createElement('div');
      var classNames = className.split(' ');
      classNames.forEach((name) => div.classList.add(name));
      if (innerHTML) div.innerHTML = innerHTML;
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv('arrow arrow--left', '<div><</div>');
      arrowLeft.addEventListener('click', () => slider.prev());
      arrowRight = createDiv('arrow arrow--right', '<div>></div>');
      arrowRight.addEventListener('click', () => slider.next());

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv('navigation-wrapper');
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    slider.on('created', () => {
      markup();
    });
    slider.on('optionsChanged', () => {
      markup(true);
      markup();
    });
    slider.on('destroyed', () => {
      markup(true);
    });
  }

  document.querySelectorAll("[id*='up-sm-perso-slider']").forEach((carousel) => {
    new KeenSlider(
      carousel,
      {
        mode: 'snap',
        loop: true,
        slides: {
          origin: 'center',
          perView: 1,
          spacing: 15,
        },
      },
      [navigationBarby]
    );
  });
}

if (document.querySelector("[id*='up-bts-perso-slider']")) {
  function navigationBackToSchool(slider) {
    let wrapper, arrowLeft, arrowRight, dots;

    function markup(remove) {
      wrapperMarkup(remove);
      arrowMarkup(remove);
      dotMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className, innerHTML) {
      var div = document.createElement('div');
      var classNames = className.split(' ');
      classNames.forEach((name) => div.classList.add(name));
      if (innerHTML) div.innerHTML = innerHTML;
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv('arrow arrow--left', '<div><</div>');
      arrowLeft.addEventListener('click', () => slider.prev());
      arrowRight = createDiv('arrow arrow--right', '<div>></div>');
      arrowRight.addEventListener('click', () => slider.next());

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv('up-slider_dots');
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv('up-slider_dot');
        dot.addEventListener('click', () => slider.moveToIdx(idx));
        dots.appendChild(dot);
      });
      wrapper.appendChild(dots);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      Array.from(dots.children).forEach(function (dot, idx) {
        idx === slide ? dot.classList.add('up-slider_dot--active') : dot.classList.remove('up-slider_dot--active');
      });
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv('navigation-wrapper');
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    slider.on('created', () => {
      markup();
      updateClasses();
    });
    slider.on('optionsChanged', () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on('slideChanged', () => {
      updateClasses();
    });
    slider.on('destroyed', () => {
      markup(true);
    });
  }

  document.querySelectorAll("[id*='up-bts-perso-slider']").forEach((carousel) => {
    new KeenSlider(
      carousel,
      {
        mode: 'snap',
        loop: true,
        slides: {
          origin: 0,
          perView: 2.4,
          spacing: 0,
        },
        breakpoints: {
          '(max-width: 989px)': {
            slides: {
              origin: 0,
              perView: 1.5,
              spacing: 0,
            },
          },
        },
      },
      [navigationBackToSchool]
    );
  });
}
